import type { ValidateFunction } from 'ajv';
import {
  assertDataIsValid,
  type BasicValidator,
} from 'common/utils/ajv-validation';

export function assertValidResponse(response: Response) {
  if (!response.ok) {
    throw new Error(`${response.status} ${response.statusText}`);
  }
}

export async function assertDataSchemaResponse<T>(
  response: Response,
  validator: ValidateFunction<T> | BasicValidator<T>,
): Promise<T> {
  assertValidResponse(response);

  const data: unknown = await response.json();

  try {
    assertDataIsValid(validator, data);
  } catch (e: any) {
    e.message = `${response.url}: ${e.message}`;
    // eslint-disable-next-line no-console
    console.error('DATA', data);
    throw e;
  }
  return data;
}

export async function assertBasicSuccess(response: Response) {
  assertValidResponse(response);

  const data = await response.json();
  if (data.success) {
    return;
  }
  throw new Error('Unknown error');
}
